import { useQuery } from '@tanstack/react-query';
import { adminLocalizationApi, adminLocalizationKeys } from '@/api';
import { sortWithNulls } from '@/utils/helpers';
import { useEffect, useState } from 'react';

export const useProductSections = (productId, visibleConditions) => {
  const [dataSorted, setDataSorted] = useState(null);
  const [loading, setLoading] = useState(true);
  const [answers, setAnswers] = useState([]);
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [adminLocalizationKeys.getProductsSections],
    queryFn: () => adminLocalizationApi.getProductsSections({ productId: productId }),
    select: (res) => res.data,
    enabled: !!productId
  });

  useEffect(() => {
    if (!productId || !data || !data.length || isLoading) return;

    let answrs = [];
    const dataToSort = [...data];

    const sorted = dataToSort
      .map((section) => {
        const filteredGroups = section.productGroups
          .map((group) => {
            const filteredQuestions = group.productQuestions
              .filter(
                (question) =>
                  question.productAvailableAnswers && question.productAvailableAnswers.length > 0
              )
              .map((question) => {
                question.productAvailableAnswers.forEach((answer) => {
                  if (
                    visibleConditions &&
                    Array.isArray(visibleConditions) &&
                    visibleConditions.length
                  ) {
                    const found = visibleConditions.find((cond) => cond.value === answer.id);
                    if (found) {
                      answrs.push(answer);
                    }
                  }
                });

                return {
                  ...question,
                  productAvailableAnswers: [...question.productAvailableAnswers].sort((a, b) =>
                    sortWithNulls(Number(a.sortOrder), Number(b.sortOrder))
                  )
                };
              })
              .sort((a, b) => sortWithNulls(Number(a.sortOrder), Number(b.sortOrder)));

            return { ...group, productQuestions: filteredQuestions };
          })
          .filter((group) => group.productQuestions.length > 0)
          .sort((a, b) => sortWithNulls(Number(a.sortOrder), Number(b.sortOrder)));

        return { ...section, productGroups: filteredGroups };
      })
      .filter((section) => section.productGroups.length > 0)
      .sort((a, b) => sortWithNulls(Number(a.sortOrder) - Number(b.sortOrder)));

    setLoading(false);
    setDataSorted(sorted);
    setAnswers(answrs);
  }, [data, isLoading, visibleConditions]);

  return {
    isLoading,
    isError,
    data,
    error,
    dataSorted,
    loading,
    answers,
    setAnswers
  };
};
